import { MessagePage } from "@/components/shared/errors/message-page"

export function NotFound() {
	return (
		<MessagePage
			title="404"
			description="We couldn't find the page you were looking for!"
		/>
	)
}
